import { render, staticRenderFns } from "./trigger_fixed.vue?vue&type=template&id=23db9d50&scoped=true&"
import script from "./trigger_fixed.vue?vue&type=script&lang=js&"
export * from "./trigger_fixed.vue?vue&type=script&lang=js&"
import style0 from "./trigger_fixed.vue?vue&type=style&index=0&id=23db9d50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db9d50",
  null
  
)

export default component.exports